import React from 'react';
import { HelpBlock } from 'react-bootstrap';

const Error = ({ meta: { touched, error } }) => (touched && error ? <HelpBlock>{error}</HelpBlock> : null);

const RolesGroup = ({ label, required, name, options, input, meta, disabled }) => {
  return <div>
    {options && options.map((option, index) => (
      <div className="checkbox" key={index}>
        <label>
          <input
            type="checkbox"
            disabled={disabled}
            name={input.name}
            value={option.name}
            checked={input.value && input.value.map(e => e.id).indexOf(option.id) !== -1}
            onChange={event => {
              const newValue = [];
              if (event.target.checked) {
                if (input.value.length > 0) {
                  input.value.forEach(item => {
                    newValue.push(item);
                  });
                }
                newValue.push(option);
                return input.onChange(newValue);
              }
              else {
                const newArr = input.value.filter(item => item.id !== option.id);
                return input.onChange(newArr);
              }
            }}
          />
          {option.name}
        </label>
      </div>
    ))}
    <Error meta={meta} />
  </div>;
};

export default RolesGroup;



// WEBPACK FOOTER //
// ./src/routes/administration/components/RolesGroup.js